import axios from 'axios';

// Separate client so the app JWT interceptor on the default axios instance
// cannot overwrite Authorization with the session access token.
const externalClient = axios.create();

const EXTERNAL_API_BASE =
  process.env.REACT_APP_EXTERNAL_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.moonscroll.ai'
    : 'http://localhost:8001');

/**
 * Isolated axios client for playground calls to the external API.
 * Does not use the JWT interceptor from utils/axios.js.
 */
export function getExternalApiBaseUrl() {
  return EXTERNAL_API_BASE.replace(/\/$/, '');
}

export function runExternalApiRequest({ method, path, apiKey, query = {}, body = null }) {
  const url = new URL(path.startsWith('http') ? path : `${getExternalApiBaseUrl()}${path}`);
  Object.entries(query || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      url.searchParams.set(key, value);
    }
  });

  return externalClient({
    method: (method || 'GET').toLowerCase(),
    url: url.toString(),
    headers: {
      Authorization: `Bearer ${apiKey}`,
      'Content-Type': 'application/json',
    },
    data: body && method && method.toUpperCase() !== 'GET' ? body : undefined,
    validateStatus: () => true,
  });
}

export function buildExternalRequestUrl({ path, query = {} }) {
  const url = new URL(path.startsWith('http') ? path : `${getExternalApiBaseUrl()}${path}`);
  Object.entries(query || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== '') {
      url.searchParams.set(key, value);
    }
  });
  return url.toString();
}

export function buildSnippet({ mode, method, url, apiKey, body }) {
  const m = (method || 'GET').toUpperCase();
  if (mode === 'curl') {
    const bodyPart =
      body && m !== 'GET'
        ? ` \\\n  -H "Content-Type: application/json" \\\n  -d '${JSON.stringify(body)}'`
        : '';
    return `curl -X ${m} "${url}" \\\n  -H "Authorization: Bearer ${apiKey}"${bodyPart}`;
  }
  if (mode === 'python') {
    const bodyLine =
      body && m !== 'GET'
        ? `,\n    json=${JSON.stringify(body, null, 4).replace(/\n/g, '\n    ')}`
        : '';
    return `import requests\n\nresponse = requests.request(\n    "${m}",\n    "${url}",\n    headers={"Authorization": "Bearer ${apiKey}"}${bodyLine}\n)\nprint(response.status_code)\nprint(response.json())`;
  }
  // javascript
  const bodyLine =
    body && m !== 'GET' ? `,\n  body: JSON.stringify(${JSON.stringify(body)})` : '';
  return `const response = await fetch("${url}", {\n  method: "${m}",\n  headers: {\n    Authorization: "Bearer ${apiKey}",\n    "Content-Type": "application/json",\n  }${bodyLine}\n});\nconst data = await response.json();\nconsole.log(response.status, data);`;
}
